import { apiRequest } from "@/utils/common/serviceApiHelper/serviceApiUtils";

import type { RequestBookingTransactionDataInterface } from "./paymentServiceInterfaces/getPaymentTransactionStatusInterface";
import { ResponseBookingTransactionData } from "./paymentServiceInterfaces/getPaymentTransactionStatusInterface";

class PaymentServiceApi {
  private baseUrl: string;

  private basePathV2: string;

  private basePath: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
    this.basePath = "payment";
    this.basePathV2 = "v2/";
  }

  async getTransactionStatus(params: RequestBookingTransactionDataInterface) {
    const queryParams = new URLSearchParams(params as any);
    const response = (await apiRequest(
      this.baseUrl,
      `${this.basePathV2}payment/GetTransactionStatus?${queryParams}`,
      "GET",
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false,
    )) as any;
    return new ResponseBookingTransactionData(response);
  }
}

export default PaymentServiceApi;
